import {ref} from 'vue';

export default {
    install: (app, options) => {
        const materials = ref([]);

        const loadMaterials = () => {
            window.lazy_axios.get('/materials/screens/?all=true')
                .then((response) => {
                    if (response.data.materials) {
                        materials.value = response.data.materials;
                    }
                });
        };

        app.provide('materials', materials);
        app.provide('loadMaterials', loadMaterials);
    },
}
